(function ($) {
	$(function () {
		$(".main-product-list-category select[name=category]").on("change first", function (e) {
			let $target	=	$(this);
			let label	=	$target.find("option:selected").text();

			$(".main-product-list-category-label").text(label);

			if(e.type == "change") {
				if($target.val()) {
					location.href	=	"/product/category/"+ $target.val();
				}
				else {
					location.href	=	"/product/";
				}
			}
		}).trigger("first");
		
		//スライド
		if($(".main-product-detail").length != 0) {
			$(".main-product-detail-photo-extends").show();
			$(".main-product-detail-photo-extends").slick();

			$(".main-product-detail-photo-thumbnail").on("click", function () {
				$('.main-product-detail-photo-extends').slick('slickGoTo', $(this).attr("data-no"));
			});
		}
	});
})(jQuery);